import { Badge } from "@bcc/components/ui/badge";
import { getStatusBadgeVariant } from "@bcc/lib/types/invoice";
import type { PurchaseOrderInvoice } from "@shared/types/payout";
import { CellContext } from "@tanstack/react-table";

export const InvoiceStatusCell = (props: CellContext<PurchaseOrderInvoice, unknown>) => {
  const status = props.getValue() as PurchaseOrderInvoice["invoiceStatus"];

  return <Badge variant={getStatusBadgeVariant(status)}>{status}</Badge>;
};
